( function () {
	'use strict';
	/* eslint max-params:0 */
	/* eslint-disable max-params */
	function WidgetCtrl ( $scope, logger, $modal, $location, persistence, _, templateView ) {
		var self = this;

		function redirectObsList ( active ) {
			// this will be removed if viewing in-Review is included in the dashboard
			if ( active === 1 ) {
				active = active + 1;
			}

			persistence.observationsActiveList = active;
			$location.path( '/observations/' );
		}

		function startObsModal () {
			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/observations/observation-start/start-obs-modal.html',
				'controller'   : 'StartObsModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false
			} );

			modalInstance.result.then( function ( res ) {
				$location.path( '/observations/' + res.id + '/edit' );
			} );
		}

		function schedObsModal ( active ) {
			persistence.scheduleActiveList = active + 1;

			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/schedules/create-schedule/create-schedule-modal.html',
				'controller'   : 'CreateScheduleModalCtrl',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {
					'dateModel' : function () {
						return self.date;
					}
				}
			} );

			modalInstance.result.then( function () {
				self.redirectCalendar();
			} );
		}

		function redirectCalendar () {
			$location.path( '/calendar/' );
		}

		function redirectReportFirstLink () {
			$location.url( '/report/component?report=results-by-item-report' );
		}

		function redirectReportSecondLink () {
			$location.path( '/report/data-export' );
		}

		function redirectReport () {
			$location.path( '/report/' );
		}

		function createTempModal () {
			$modal.open( {
				'templateUrl'  : '/templates/templates/create-new/create-new-modal.html',
				'controller'   : 'CreateNewTemplateModal',
				'controllerAs' : 'vm',
				'keyboard'     : false,
				'resolve'      : {}
			} ).result.then( function ( data ) {
				templateView.setViewOnly( false );
				$location.path( '/template/' + data.id );
			} );
		}

		function redirectTempList ( active ) {
			persistence.templatesActiveList = active;
			$location.path( '/templates/' );
		}

		function activate () {
			self.action = _.filter( $scope.action, { 'level' : $scope.index } );
			logger.info( 'Activated Widget View' );
		}

		self.startObsModal            = startObsModal;
		self.redirectObsList          = redirectObsList;
		self.schedObsModal            = schedObsModal;
		self.redirectCalendar         = redirectCalendar;
		self.redirectReportFirstLink  = redirectReportFirstLink;
		self.redirectReportSecondLink = redirectReportSecondLink;
		self.redirectReport           = redirectReport;
		self.createTempModal          = createTempModal;
		self.redirectTempList         = redirectTempList;

		activate();
	}

	angular
		.module( 'app.dashboard' )
		.controller( 'WidgetCtrl', WidgetCtrl );

	WidgetCtrl.$inject = [ '$scope', 'logger', '$modal', '$location', 'persistence', '_', 'templateView' ];
} )( );
